module.exports = __webpack_public_path__ + "81fc395c76b2c3012f33b1a5e0404f77.svg";